import { AxiosInstance } from 'axios'
import { BaseHTTP } from './base.http'

export class CentroCostosAPI {
  private http!: AxiosInstance

  constructor() {
    this.http = BaseHTTP.getInstance().http
  }

  postCreate(businessId: number, payload: any) {
    const path = `v1/centro-costos/business/${businessId}`
    return this.http.post(path, payload)
  }

  getCentroCostos(businessId: number) {
    const path = `v1/centro-costos/business/${businessId}`
    return this.http.get(path)
  }

  getOneCentroCosto(businessId: number, centroId: number) {
    const path = `v1/centro-costos/business/${businessId}/find-one/${centroId}`
    return this.http.get(path)
  }

  updateCentroCosto(businessId: number, centroId: number, payload: any) {
    const path = `v1/centro-costos/business/${businessId}/${centroId}`
    return this.http.patch(path, payload)
  }

  deleteCentroCosto(businessId: number, idCentroCosto: number) {
    return this.http.delete(`v1/centro-costos/business/${businessId}/delete/${idCentroCosto}`)
  }

  createLibroCentroCosto(businessId: number, libroId: number, payload: any, temporalidad = 0) {
    const path = `v1/centro-costos/business/${businessId}/libro-contable/${libroId}`
    return this.http.post(path, payload, {
      params: { temporalidad: Number(temporalidad) || 0 }
    })
  }

  createLibrosCentroCosto(businessId: number, payload: any, reemplazar = true) {
    const path = `v1/centro-costos/business/${businessId}/libros-contables`
    if (reemplazar === false) {
      return this.http.post(path, payload, {
        params: { reemplazar: false }
      })
    }

    return this.http.post(path, payload)
  }
}

export default new CentroCostosAPI()
